import { InjectionToken } from '@angular/core';
import { ScrollModuleConfig } from '../models/scroll-module-config';

export const CONFIG: InjectionToken<ScrollModuleConfig> = new InjectionToken<ScrollModuleConfig>(
  'CONFIG'
);
